import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { sendPasswordReset } from "../firebase";
import ResetCard from "../components/reset/ResetCard";
import { useSnack } from "../contexts/AlertContext";

const Reset = () => {
  const navigate = useNavigate();
  const setSnack = useSnack();

  const handleReset = async (data) => {
    const { email } = data;
    try {
      await sendPasswordReset(email);
      navigate("/login");
      setSnack({
        open: true,
        type: "success",
        message: "Password reset email sent. Please check your email."
      });
    } catch (e) {
      setSnack({
        open: true,
        type: "error",
        message: "An error occured resetting your password. Please try again."
      });
    }
  };

  return (
    <Box sx={{ marginX: "auto", marginTop: "20%", maxWidth: 600 }}>
      <ResetCard onReset={handleReset} />
    </Box>
  );
};

export default Reset;
